/**
 * jQuery plugin to lazy load slick sliders
 * created by bogdan.b@codingheads.com
 * requires IntersectionObserver, activateOnScroll.js, slick.js
 *
 * version 0.1
 */

jQuery(function($) {
  $.fn.lazySlick = function(
    slickArgs = {},
    activateOnScrollArgs = {
      options: {
        rootMargin: '500px 100px',
      },
    }
  ) {
    if (this.length) {
      this.each(function() {
        const $this = $(this);
        this.dataset.lazySlick = true;
        this.classList.add('lazy-slick');

        // lazy load slider
        let sliderLoaded = false;
        $this.activateOnScroll({
          ...activateOnScrollArgs,
          callback: () => {
            if (sliderLoaded) return;
            sliderLoaded = true;
            if ('asNavFor' in slickArgs) {
              $(slickArgs.asNavFor).trigger('activateOnScroll');
            }

            $this
              .on('init', () => {
                if ('chMatchHeight' in window) {
                  chMatchHeight($this);
                }
                $this
                  .find('.slick-cloned .animation-started[data-fade-in]')
                  .css({
                    opacity: 1,
                    width: '',
                    height: '',
                  });
              })
              .slick(slickArgs);
          },
        });
      });
    }
    return this;
  };
});
